import _ from 'underscore';

export const getBackgroundChangeODataService = ({
  odata, oDataConfig, aid, cid,
}) => {
  const removeImageBackground = (imageUrl) => {
    const url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})/Images/Default.RemoveBackground`;
    const requestBody = {
      Url: imageUrl,
    };
    return odata.post(url, _.extend({ data: requestBody }, oDataConfig));
  };

  const getImageSegmentations = (imageUrl) => {
    const url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})/Images/Default.GetImageSegmentation`;
    const requestBody = {
      ImageUrl: imageUrl,
    };
    return odata.post(url, _.extend({ data: requestBody }, oDataConfig));
  };

  const generateImageBackground = ({
    prompt,
    // it could be original image url, in such case, the selectedMasks contains the mask ids user selected
    // if it's the url returned from 'removeImageBackground', the selectedMasks should be null
    imageUrl,
    // array of mask ids, if it's empty [], it means no mask is selected
    // if it's null, it means no masks are applied
    maskSetsBase64,
    selectedMasks,
    outputImageWidth,
    outputImageHeight,
  }) => {
    const url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})/Images/Default.GenerateImageBackground`;
    const requestBody = {
      ImageUrl: imageUrl,
      Prompt: prompt,
      MaskSets: maskSetsBase64,
      SelectedMasks: selectedMasks,
      Width: outputImageWidth,
      Height: outputImageHeight,
    };
    return odata.post(url, _.extend({ data: requestBody }, oDataConfig));
  };

  const generateImageBackgrounds = ({
    prompt,
    imageUrl,
    maskSetsBase64,
    selectedMasks,
    outputImageWidth,
    outputImageHeight,
  }) => {
    const url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})/Images/Default.GenerateImageBackgrounds`;
    const requestBody = {
      ImageUrl: imageUrl,
      Prompt: prompt,
      MaskSets: maskSetsBase64,
      SelectedMasks: selectedMasks,
      Width: outputImageWidth,
      Height: outputImageHeight,
    };
    console.log(url, requestBody);
    // return odata.post(url, _.extend({ data: requestBody }, oDataConfig));
    // eslint-disable-next-line no-restricted-globals
    return Promise.resolve({ TaskId: 1 });
  };

  const getGeneratedBackgroundImagesTaskStatus = (taskId) => {
    const url = `${oDataConfig.oDataPath}/Customers(${cid})/Accounts(${aid})/Images/Default.GenerateImageBackgrounds(TaskId='${taskId}')`;
    console.log(url);
    // return odata.get(url, oDataConfig);
    // eslint-disable-next-line no-restricted-globals
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          TaskStatus: 'Completed',
          progress: 100,
          Images: [
            {
              GeneratedBackgroundImage: { ImageURL: 'https://aggsvcstoragedev.z13.web.core.windows.net/background-recommendation/generated_20250409025711958_61fb72e6-6ced-43dd-954b-cee55cedb23d.jpg', Source: 'AIModel' },
            },
            {
              GeneratedBackgroundImage: { ImageURL: 'https://aggsvcstoragedev.z13.web.core.windows.net/background-recommendation/generated_20250409040724100_dd5604c2-ee72-4e54-909b-ee9a17008eba.jpg', Source: 'AIModel' },
            },
            {
              GeneratedBackgroundImage: { ImageURL: 'https://aggsvcstoragedev.z13.web.core.windows.net/background-recommendation/generated_20250409040815818_fc3b6ecc-e072-46a1-b769-10c6e9dca1df.jpg', Source: 'AIModel' },
            },
            {
              GeneratedBackgroundImage: { ImageURL: 'https://aggsvcstoragedev.z13.web.core.windows.net/background-recommendation/generated_20250409040852103_548fc68d-3f73-4ea5-8ebc-bbd570b93896.jpg', Source: 'AIModel' },
            },
          ],
        });
      }, 200);
    });
  };

  return {
    removeImageBackground,
    getImageSegmentations,
    generateImageBackground,
    generateImageBackgrounds,
    getGeneratedBackgroundImagesTaskStatus,
  };
};

